import { render, staticRenderFns } from "./basic-info-view.vue?vue&type=template&id=8b831f0a&"
import script from "./basic-info-view.vue?vue&type=script&lang=js&"
export * from "./basic-info-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports